export default __webpack_public_path__ + "static/media/brandLogoShort.1deeff32.1deeff32.webp";